import { useLocation } from '@solidjs/router';
import { on, createEffect } from 'solid-js';
import usePresenter from '~/framework/hooks/usePresenter';
import { CompanyInfoPresenter } from '~/presenters/CompanyInfoPresenter';
import { TenantInfoPresenter } from '~/presenters/TenantInfoPresenter';

export const Intercom = () => {
  const location = useLocation();

  const { model: tenantInfo } = usePresenter(TenantInfoPresenter);
  const { model: companyInfo } = usePresenter(CompanyInfoPresenter);

  createEffect(
    on(
      () => tenantInfo()?.id,
      () => {
        if (!tenantInfo()?.id) return;
        window.Intercom('boot', {
          api_base: 'https://api-iam.intercom.io',
          app_id: 'yk2iavay',
          user_id: tenantInfo()?.id,
          name: tenantInfo()?.name,
          email: tenantInfo()?.email,
          company: {
            id: companyInfo()?.companyId,
            name: companyInfo()?.companyName,
          },
        });
      }
    )
  );

  createEffect(
    on(
      () => [location.pathname, tenantInfo()?.id, companyInfo()?.companyId],
      () => window.Intercom('update')
    )
  );
  return null;
};
